<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col sm="10">
            <h3>{{$route.name}}</h3>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-form v-on:submit.prevent="onSubmit">
          <b-row>
            <b-col sm="4">
              <b-form-group label="Categoria: *">
                <b-input-group>
                  <b-form-select
                    :options="categorias"
                    v-model="$v.form.categoria.$model"
                    :disabled="disable_buttons || visualizar"
                    :state="chkState('categoria')">
                    <option :value="null">Selecione</option>
                  </b-form-select>
                  <b-form-invalid-feedback>Categoria é obrigatória.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Descrição: *">
                <b-input-group class="mb-6">
                  <b-form-textarea
                    v-model="$v.form.descricao.$model"
                    :disabled="disable_buttons || visualizar"
                    :state="chkState('descricao')">
                  </b-form-textarea>
                  <b-form-invalid-feedback>Descrição é obrigatória.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="!visualizar">
            <b-col cols="12">
              <b-form-group label="Arquivo:">
                <b-input-group class="mb-6">
                  <b-form-file
                    ref="file-input-1"
                    accept=".pdf, .jpg, .jpeg, .png"
                    browse-text="Selecione"
                    :placeholder="$v.form.arquivo.$model | nameFile"
                    :disabled="disable_buttons || visualizar"
                    v-on:change="uploadArquivo"
                  ></b-form-file>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col v-if="$v.form.arquivo.$model" sm="12">
              <b-form-group label="Arquivo:">
                <b-input-group v-if="imgDownload" class="mb-6">
                  <b-img center :src="$v.form.arquivo.$model" fluid alt="Imagem"></b-img>
                </b-input-group>
                <b-input-group v-else class="mb-6">
                  <b-button variant="primary" v-on:click="download()"><i class="fa fa-download"></i> &nbsp; Download</b-button>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col v-else sm="12">
              <b-form-group label="Arquivo:">
                <p>Nenhum arquivo ou imagem disponibilizado.</p>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col v-if="!visualizar" md="3" offset-md="3">
            <b-button :disabled="disable_buttons" block variant="primary" v-on:click="onSubmit">
              <i class="fa fa-check"></i>&nbsp;
              <span>Salvar</span>
            </b-button>
          </b-col>
          <b-col md="3">
            <b-button :disabled="disable_buttons" block variant="secondary" @click="$router.go(-1)">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </span>
</template>

<script>
import 'v-markdown-editor/dist/v-markdown-editor.css'
import Vue from 'vue'
import AuthTemplate from '@/templates/auth/AuthTemplate'
import VueSelect from 'vue-select'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Editor from 'v-markdown-editor'
import CKEditor from 'ckeditor4-vue'
import SessionStorage from '@/services/session-storage'

miniToastr.init()
Vue.use(Editor)
Vue.use(CKEditor)

const formShape = {
  categoria: '',
  descricao: '',
  arquivo: null
}

export default {
  name: 'Cadastro',
  components: {
    AuthTemplate,
    VueSelect,
    Editor
  },
  mixins: [validationMixin],
  validations: {
    form: {
      categoria: {
        required
      },
      descricao: {
        required
      },
      arquivo: {}
    }
  },
  created () {
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') !== 'A') {
      this.$router.push('/')
    }

    if (this.$route.path.includes('visualizar')) {
      this.visualizar = true
    }

    if (this.$route.params.id) {
      this.load(this.$route.params.id)
    }
  },
  data () {
    return {
      form: Object.assign({}, formShape),
      id: null,
      categorias: {
        BN: 'Beneficiária',
        VL: 'Voluntária',
        SM: 'Saiba Mais'
      },
      editorConfig: {
        removePlugins: 'elementspath,resize,codesnippet'
      },
      salvarForm: false,
      visualizar: false,
      disable_buttons: false
    }
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    },
    imgDownload () {
      if (this.$v.form.arquivo) {
        return this.$v.form.arquivo.$model.match(/.(jpg|jpeg|png|gif)$/i)
      }
    }
  },
  filters: {
    nameFile (value) {
      if (value !== null && value !== '' && value !== []) {
        var n = value.lastIndexOf('/')
        var file = value.substring(n + 1)
        return file
      } else {
        return 'Selecione um arquivo'
      }
    }
  },
  methods: {
    salvar () {
      let form = this.$v.form
      this.disable_buttons = true

      let data = {
        id: this.id,
        categoria: form.categoria.$model,
        descricao: form.descricao.$model,
        arquivo: form.arquivo.$model
      }

      Vue.http.post('api/texto-app', data).then((response) => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.$router.push({ path: '/textos' })
        } else {
          this.disable_buttons = false
          miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
      }).catch((e) => {
        this.disable_buttons = false
      })
    },
    load (id) {
      Vue.http.get('api/texto-app/' + id).then((response) => {
        this.form.categoria = response.body.data[0].categoria
        this.form.descricao = response.body.data[0].descricao
        this.form.arquivo = response.body.data[0].arquivo
        this.id = response.body.data[0].id
      })
    },
    uploadArquivo (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      if (arquivo[0].size > 10000000) {
        miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
        miniToastr.error('Arquivo não pode ser maior que 10mb!', 'Alerta', 5000)
        this.$refs['file-input-1'].reset()
        return false
      }

      if (!(arquivo[0].type.match(/.(pdf|jpg|jpeg|png)$/i))) {
        miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
        miniToastr.error('Arquivo só pode ser do tipo imagem ou PDF!', 'Alerta', 5000)
        this.$refs['file-input-1'].reset()
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.$v.form.arquivo.$model = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },
    download () {
      window.open(this.$v.form.arquivo.$model, '_blank')
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then((valor) => {
        if (valor) {
          this.salvar()
        }
      })
    },
    onSubmit () {
      this.salvarForm = true
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState (val) {
      if (this.salvarForm && !this.visualizar) {
        const field = this.$v.form[val]
        return !field.$dirty || !field.$invalid
      }
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/textoApresentacao/TextoForm.vue